import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { isEmptyOrNil } from 'libs/empty'
import { Typography } from '@material-ui/core'
import EventBusyIcon from '@material-ui/icons/EventBusy'

const EventCancel = (props) => {
  const { reason = null } = props

  const { formatMessage } = useIntl()

  return (
    <>
      <Typography
        component="p"
        className="text-red-500 text-12 break-all flex items-center"
      >
        <EventBusyIcon className="mr-3 text-grey-200" fontSize="small" />
        {formatMessage({ id: 'text.status.canceled' })}
      </Typography>
      {isEmptyOrNil(reason) ? null : (
        <div className="flex space-x-3">
          <Typography className="text-12">
            <span className="text-grey-300 mr-3">
              {formatMessage({ id: 'timeline.detail.message.cancel.reason' })}
            </span>
            <span className="text-red-500">{reason}</span>
          </Typography>
        </div>
      )}
    </>
  )
}

EventCancel.propTypes = {
  reason: PropTypes.string,
}

export default EventCancel
